import RateReviewIcon from '@material-ui/icons/RateReview';

import List from './ReviewList';
import show from './ReviewShow';
import Create from './ReviewCreate';

export default {
    list: List,
    show: show,
    create: Create,
    icon: RateReviewIcon,
};
